import BoardMaster from '../../features/masters/BoardMaster'

const BoardPage = () => {
  return <BoardMaster />
}

export default BoardPage